import React from "react";
import { useSelector, shallowEqual } from 'umi';

export default () => {

  const { showGlobalMask } = useSelector(state => {
    // @ts-ignore
    const { showGlobalMask } = state.home;
    return {
      showGlobalMask
    };
  }, shallowEqual);
  return <>
    {(showGlobalMask) && <div className={`db-global-mask ${showGlobalMask === 'transparent' && `db-global-mask-transparent`}`}></div>}
  </>;
};
